/**
 * BrandIT Posts Lazy Loader
 * 
 * Loads external BrandIT posts only when the section is visible in viewport
 * Uses Intersection Observer API for performance optimization
 */

const BranditPostsLazyLoader = (function () {
	let hasLoaded = false;

	/**
	 * Load BrandIT posts via AJAX
	 */
	function loadBrandItPosts(brandItLoader) {
		const container = brandItLoader.querySelector('.brandit-posts-container');
		const perPage = brandItLoader.getAttribute('data-per-page') || 3;

		// Prepare form data
		const formData = new FormData();
		formData.append('action', 'fetch_brandit_posts');
		formData.append('nonce', touchitAjax.brandItNonce);
		formData.append('per_page', perPage);

		// Make AJAX request
		fetch(touchitAjax.ajaxurl, {
			method: 'POST',
			credentials: 'same-origin',
			body: formData
		})
		.then(response => response.json())
		.then(data => {
			if (data.success && data.data.html) {
				// Fade out skeleton
				container.style.opacity = '0';
				container.style.transition = 'opacity 0.3s ease-out';
				
				setTimeout(() => {
					// Replace loading placeholder with actual posts
					container.innerHTML = data.data.html;
					brandItLoader.classList.add('loaded');
					
					// Fade in actual content
					container.style.opacity = '1';
					
					// Trigger any lazy load images if needed
					if (typeof window.lazySizes !== 'undefined') {
						window.lazySizes.autoSizer.checkElems();
					}
				}, 300);
			} else {
				// Show error message
				container.innerHTML = '<p class="brandit-error">' + 
					(data.data.message || 'Momentálne nie je možné načítať príspevky z BrandIT.') + 
					'</p>';
				brandItLoader.classList.add('loaded');
			}
		})
		.catch(error => {
			console.error('Error loading BrandIT posts:', error);
			container.innerHTML = '<p class="brandit-error">Chyba pri načítavaní príspevkov.</p>';
			brandItLoader.classList.add('loaded');
		});
	}

	/**
	 * Initialize Intersection Observer
	 */
	function initObserver() {
		const brandItLoader = document.querySelector('[data-brandit-loader]');
		
		if (!brandItLoader) {
			return;
		}

		// Create Intersection Observer
		const observerOptions = {
			root: null, // Use viewport as root
			rootMargin: '200px', // Start loading 200px before element is visible
			threshold: 0.1
		};

		const observerCallback = (entries, observer) => {
			entries.forEach(entry => {
				// Only load once when element comes into view
				if (entry.isIntersecting && !hasLoaded) {
					hasLoaded = true;
					loadBrandItPosts(brandItLoader);
					observer.unobserve(entry.target);
				}
			});
		};

		const observer = new IntersectionObserver(observerCallback, observerOptions);
		observer.observe(brandItLoader);
	}

	return {
		init: function () {
			initObserver();
		}
	};
})();

export default BranditPostsLazyLoader;

